<!-- 配件销售历史 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn" style="min-height: 0;margin-top:10px;">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button class="search-btn btn-primary" size="small" @click="chooseAPs()">确定 (选中{{ selection.length }}项)</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%; margin-bottom: 0px"
                @selection-change="onColumnSelect"
                :row-key="getRowKeys"
                @row-dblclick="rowClick"
            >
                <el-table-column type="selection" width="55" reserve-selection :selectable="selectInit"></el-table-column>
                <el-table-column width="160px" prop="APCode" label="汽配编码" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.APCode }} </i>
                        <i v-else>{{ scope.row.APCode }} </i>
                    </template>
                </el-table-column>
                <el-table-column prop="GoodsName" label="配件名称" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.GoodsName }} </i>
                        <i v-else>{{ scope.row.GoodsName }} </i>
                    </template>
                </el-table-column>
                <el-table-column prop="AutoSerise" label="适用车型" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.AutoSerise }} </i>
                        <i v-else>{{ scope.row.AutoSerise }} </i>
                    </template>
                </el-table-column>
                <el-table-column prop="Brand" width="80px" v-if="IsShowBrand" label="品牌" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.Brand }} </i>
                        <i v-else>{{ scope.row.Brand }} </i>
                    </template>
                </el-table-column>                
                <el-table-column prop="Origin" width="80px" v-if="IsBPriceShow" label="产地" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.Origin }} </i>
                        <i v-else>{{ scope.row.Origin }} </i>
                    </template>
                </el-table-column>
                <el-table-column prop="Size" width="70px" v-if="IsBPriceShow" label="规格" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <i v-if="scope.row.IsSelected" class="out-active">{{ scope.row.Size }} </i>
                        <i v-else>{{ scope.row.Size }} </i>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="ReturnCount" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="WarehousedCount" label="已出仓数"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="AlReturnCount" label="已退数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" label="可退数量">
                     <template slot-scope="scope">
                        <div style="color:red;" v-if="scope.row.WarehousedCount - scope.row.AlReturnCount == 0">
                            {{ scope.row.WarehousedCount - scope.row.AlReturnCount }}
                        </div>
                        <div v-else>{{ scope.row.WarehousedCount - scope.row.AlReturnCount }}</div>
                    </template>
                    </el-table-column
                >
                <el-table-column show-overflow-tooltip width="80px" v-if="!IsBPriceShow" prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" v-if="IsBPriceShow" prop="BillingPrice" label="开单价"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="SalePrice" label="售价"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!-- 销售历史 -->
        <el-dialog
            :title="SaleDialogTitle"
            :close-on-click-modal="false"
            :visible.sync="eyeHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="eyeHistoryVisible">
                <APHistory
                    ref="APHistory"
                    :showCusColumn="false"
                    :EntpCusId="EntpCusId"
                    :EntpTempGoodsId="hisGoodsId"
                    :EntpCusName="EntpCusName"
                    :NoInit="true"
                    @closeDialog="eyeHistoryVisible = false"
                ></APHistory>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import APHistory from '@/components/common/APHistory';
export default {
    name: '',
    props: {
        EntpCusOId: {
            type: String
        },
        EntpCusName: {
            type: String
        },
        DataList: {
            type: Array
        },
        IsBPriceShow: {
            type: Boolean
        },
        IsShowBrand:{
            type: Boolean
        }
    },
    components: { APHistory },
    data() {
        return {
            loading: false,
            selLoading: false,
            eyeHistoryVisible: false,
            SaleDialogTitle: '',
            hisGoodsId: '',
            typeList: [],
            brandList: [],
            customerList: [],
            searchData: {
                EntpCusOId: this.EntpCusOId,
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                APCate: [],
                Page: 1,
                Limit: 10,
                StartDate: '',
                EndDate: ''
            },
            statData: [],
            tableData: [],
            tableDataLength: 0,
            avg: 0,
            month: 0,
            year: 0,
            selection: []
        };
    },
    mounted() {
        if (this.EntpCusOId) this.searchData.EntpCusOId = this.EntpCusOId;
        else this.$.$util.warningMsg('客户信息异常，请刷新后重试');
        this.getTableData();
    },
    methods: {
        rowClick(row) {
            this.showSaleStat(row);
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        searchGoodsBrand() {
            this.selLoading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsType() {
            this.selLoading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                EntpCusOId: this.EntpCusOId,
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                APCate: [],
                Page: 1,
                Limit: 10,
                StartDate: '',
                EndDate: ''
            };
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 更新表格数据
        updateTableData(id) {
            this.resetSearch();
            this.searchData.GoodsId = id;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/GetItemsForReturnById',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                    if (this.DataList.length > 0) {
                        this.tableData.forEach(goods => {
                            let idx = this.DataList.findIndex(f => f.SaleOrderRsId == goods.SaleOrderRsId);
                            if (idx > -1) {
                                goods.IsSelected = true;
                            }
                        });
                    }
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        onColumnSelect(val) {
            this.selection = val;
        },
        //多选配件
        chooseAPs() {
            let items = this.selection;
            this.$emit('closeDialog', items);
        },
        getRowKeys(row) {
            return row.EntpTempGoodsId;
        },
        searchGoodsTypeLoad() {
            this.typeForm.Page += 1;
            this.searchGoodsType();
        },
        showSaleStat(row) {
            let that = this;
            if (row) {
                that.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodsName + ' ' + row.AutoSerise;
                that.hisGoodsId = row.EntpTempGoodsId;
                if (!that.eyeHistoryVisible) that.eyeHistoryVisible = true;
                that.$nextTick(() => {
                    that.$refs.APHistory.updateTableData(row.EntpTempGoodsId);
                });
            }
        },
        selectInit(row, index) {
            if (row.WarehousedCount - row.AlReturnCount == 0 || row.IsSelected) return false;
            else return true;
        }
    }
};
</script>
<style lang="less">
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1000px;
        // height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
